import React from 'react';

function FacebookIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <circle cx="16" cy="16" r="15.5" fill="#FFC228" stroke="#FFC228" />
      <path
        fill="#1B1F2C"
        d="M17.397 24.997V16.8h2.765l.411-3.21h-3.176v-2.043c0-.926.258-1.56 1.587-1.56h1.684V7.127c-.82-.088-1.643-.13-2.467-.127-2.444 0-4.122 1.492-4.122 4.23v2.356h-2.747v3.209h2.753v8.202h3.312z"
      />
    </svg>
  );
}

export default FacebookIcon;
